import React, { useState, useContext, useEffect } from 'react'
import './custom-signature-full-screen.css'
import { Context } from '../../../Context';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

/**
 * @export
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
export default function PdfFullScreen(props) {
    const { setShowPdf, pdf, pdfSucess, setPdfSucess } = useContext(Context);
    const { innerWidth: fullWidth, innerHeight: fullHeight } = window;
    const [pager, setPager] = useState(1)
    const [pageNumber, setPageNumber] = useState(1)
    const [numPages, setNumPages] = useState(null);

    const onDocumentLoadSuccess = (params) => {
        setNumPages(params.numPages);
        setPageNumber(1)
        setPager(1)
    }

    const changePage = (offset) => {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
        setPager(prevPageNumber => prevPageNumber + offset)
    }
    const previousPage = () => {
        if (pageNumber <= 1) return
        changePage(-1);
    }

    const nextPage = () => {
        if (pageNumber >= numPages) return
        changePage(1);
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    })

    useEffect(() => {
        if (props.visibleDialogTimerSignOff) {
            setShowPdf(false)
        }
    }, [props.visibleDialogTimerSignOff])

    return !pdf ? null : (
        <div class="grid-container-pdf">
            <div class="pdf">
                <Document
                    file={pdf}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={props.children}
                    onLoadError={e => console.log({ e })}
                >
                    <Page pageNumber={pageNumber} width={fullWidth * 0.8} height={fullHeight * 0.8} />
                </Document>
            </div>
            <div class="controlPdfBtns">
                <span class="k-icon k-i-arrow-double-60-left icon-bar" onClick={() => {
                    setPageNumber(1);
                    setPager(1)
                }} ></span>
                <span class="k-icon k-i-arrow-60-left icon-bar" onClick={previousPage} ></span>
                <div className="pagec" style={{ color: '#427FBA', textAlign: 'center', fontWeight: 'bold', marginTop: 'auto', marginBottom: 'auto', padding: '0px 5px' }}>
                    Página
                    <input style={{ width: '32px', marginLeft: '4px', marginRight: '3px' }} type="text" value={pager} onChange={({ target }) => {
                        setPager(Number(target.value))
                        if (Number(target.value) <= numPages) {
                            if (Number(target.value) <= 0) {
                                setPageNumber(1);
                                setPager(1)
                            } else setPageNumber(Number(target.value))
                        } else setTimeout(() => {
                            setPager(pageNumber)
                        }, 1000)
                    }} />
                    de {numPages || '--'}
                </div>
                <span class="k-icon k-i-arrow-60-right icon-bar" onClick={nextPage}></span>
                <span class="k-icon k-i-arrow-double-60-right icon-bar" onClick={() => {
                    setPageNumber(numPages)
                    setPager(numPages)
                }} ></span>
            </div>
            <div class="backPdf" >
                <div class="back">
                    <button onClick={() => {
                        setShowPdf(false)
                    }}>
                        {'Regresar'}
                    </button>
                </div>

                {pdfSucess && (
                    <div class="save">
                        <button
                            onClick={() => {
                                setShowPdf(false)
                                pdfSucess.onSubmit()
                                setPdfSucess(null)
                            }}
                        >
                            {'Enviar'}
                        </button>
                    </div>
                )}
            </div>

        </div >
    )
}
